module.exports = __webpack_public_path__ + "static/media/hz.da185340.svg";